import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import MPP_CHECK_TIN from './MppCheckTin.gql';

const parseResult = result => {
  const initialState = {
    mppCheckTin: [],
  };
  const checkTinResponse = get(result, 'mpp.mppCheckTin');
  return {
    ...initialState,
    mppCheckTin: checkTinResponse,
  };
};

export const useMppCheckTinQuery = options => {
  const [queryResult, queryAction] = useQuery(MPP_CHECK_TIN, {
    ...options,
    requestPolicy: 'no-cache',
    onCompleted: result => {
      options.onCompleted(parseResult(result.body.data));
    },
  });
  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
